/** 1 = ToBeExecuted 2 = Postponed */
export enum RankExecutionType {
    ToBeExecuted = 1,
    Postponed = 2,
}